import CloseIcon from '@atlaskit/icon/core/close';
import * as React from 'react';

export function SvgClose() {
  return <CloseIcon label="" testId="ads-refreshed-icon" />;
}
